import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, UntypedFormGroup, Validators } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { Team } from '../_shared/models/team.model';
import { ToastService } from '../_core/services/toast.service';
import { UserService } from '../_core/services/user.service';
import { Subject, takeUntil } from 'rxjs';
import { User } from '../_shared/models/user.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-player-number',
  templateUrl: './player-number.component.html',
  styleUrls: ['./player-number.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    ]
})
export class PlayerNumberComponent  implements OnInit, OnDestroy {
    @Input({required: true}) team: Team;
    @Input({required: true}) user: User;
    private destroy$ = new Subject<void>();
    toastService = inject(ToastService);
    userService = inject(UserService);
    translateService = inject(TranslateService);


    form: UntypedFormGroup;
    constructor(private fb: FormBuilder,) { }

    ngOnInit() {
        this.form = this.fb.group({
            jerseyNumber: ['', [Validators.required]],
        });
        this.getUserJerseyNumber();
    }

    getUserJerseyNumber() {
      const matchingParticipant = this.team.participants.find(
          (participant) => participant.person._id === this.user._id
        );
        this.form.patchValue({
          jerseyNumber: matchingParticipant?.jerseyNumber,
        });
    }
  
    saveJerseyNumber(){
      if (this.form.value.jerseyNumber.length < 1) {
          this.toastService.presentToast(this.translateService.instant('Player number must be 1 digits'), 'danger');
          return;
        }
       if (this.form.value.jerseyNumber.length > 3) {
          this.toastService.presentToast(this.translateService.instant('Player number maximum 3 digits'), 'danger');
          return;
        }
  
      if (this.form.invalid) return;

      if(this.user._id){
      if (this.form.valid && this.form.value.jerseyNumber) {
          this.userService
          .addJerseyNumber(this.team._id, this.user._id, this.form.value.jerseyNumber)
          .pipe(takeUntil(this.destroy$))
          .subscribe((response) => {
            if(response.data){
              this.toastService.presentToast(this.translateService.instant('Player number updated successfully.'), 'success');
            }
          });
        } else {
          console.error('Form is invalid');
        }
        }
    }

    validateOnlyNumber($event: any) {
        var charCode = $event.which ? $event.which : $event.keyCode;
        if (charCode < 48 || charCode > 57) {
            $event.preventDefault();
          return false;
        } else {
          return true;
        }
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
